import { Component, OnInit } from '@angular/core';
import { MsalRedirectComponent } from '@azure/msal-angular';

@Component({
  selector: 'app-redirect',
  template: '',
  standalone: true
})
export class MsalRedirectStandaloneComponent extends MsalRedirectComponent implements OnInit {
  override ngOnInit(): void {
    super.ngOnInit();
  }
}
